import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import sweetAlert from 'sweetalert'


export class Datatable_user extends Component {
    constructor(props) {
        super(props)
        this.state = {
            checkedValues: [],
            myData: this.props.myData,
        }
        this.disableIt = this.disableIt.bind(this)
    }

    disableIt = (id) => {
        const url = `${process.env['REACT_APP_HOST']}/api/users/${id}`;
        const params = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                disable: 1,
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                toast.success("User Disabled Successfully!")
                window.location.reload()
            })
    }

    enableIt = (id) => {
        const url = `${process.env['REACT_APP_HOST']}/api/users/${id}`;
        const params = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                disable: 0,
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                toast.success("User Enabled Successfully!")
                window.location.reload()
            })
    }


    selectRow = (e, i) => {
        if (!e.target.checked) {
            this.setState({
                checkedValues: this.props.checkedValues.filter((item, j) => i !== item)
            });
        } else {
            this.props.checkedValues.push(i);
            this.setState({
                checkedValues: this.props.checkedValues
            })
        }
    }

    handleRemoveRow = () => {
        const selectedValues = this.props.checkedValues;
        const updatedData = this.props.myData.filter(function (el) {
            return selectedValues.indexOf(el.id) < 0;
        });
        this.setState({
            myData: updatedData
        })
        toast.success("Successfully Deleted !")
    };

    renderEditable = (cellInfo) => {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => {
                    const data = [...this.props.myData];
                    data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
                    this.setState({ myData: data });
                }}
                dangerouslySetInnerHTML={{
                    // __html: this.props.myData[cellInfo.index][cellInfo.column.id]
                    __html: [cellInfo.original.id][0]
                }}
            />
        );
    }

    Capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    deleteHandler = (id) => {
        const url = `${process.env['REACT_APP_HOST']}/api/users/${id}`;
        const params = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            }
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
            })
    }

    render() {
        let _this = this
        const { pageSize, myClass, multiSelectOption, pagination } = this.props;
        const { myData } = this.props;
        const columns = [];
        for (var key in myData[0]) {

            let editable = this.renderEditable

            if (key === "_id") {
                editable = null;
            }
            if (key === "firstName") {
                editable = null;
            }
            if (key === "lastName") {
                editable = null;
            }
            if (key === "email") {
                editable = null;
            }
            // if (key === "isAdmin") {
            //     editable = null;
            // }

            columns.push(
                {
                    Header: <b>{this.Capitalize(key.toString())}</b>,
                    accessor: key,
                    Cell: editable,
                    style: {
                        textAlign: 'center'
                    }
                });
        }

        if (multiSelectOption == true) {
            columns.push(
                {
                    Header: <button className="btn btn-danger btn-sm btn-delete mb-0 b-r-4"
                        onClick={
                            (e) => {
                                if (window.confirm('Are you sure you wish to delete this item?'))
                                    this.handleRemoveRow()
                            }}>Delete</button>,
                    id: 'delete',
                    accessor: str => "delete",
                    sortable: false,
                    style: {
                        textAlign: 'center'
                    },
                    Cell: (row) => (
                        <div>
                            <span >
                                <input type="checkbox" name={row.original.id} defaultChecked={this.props.checkedValues.includes(row.original.id)}
                                    onChange={e => this.selectRow(e, row.original.id)} />
                            </span>
                        </div>
                    ),
                    accessor: key,
                    style: {
                        textAlign: 'center'
                    }
                }
            )
        } else {
            columns.push({
                Header: <b>Action</b>,
                id: 'delete',
                accessor: str => "delete",
                Cell: (row) => (
                    <div>
                        <button type="button" onClick={() => _this.props.changeMode(row.original._id)} class="btn btn-primary">See Sessions</button>
                    </div>
                ),
                style: {
                    textAlign: 'center'
                },
                sortable: false
            })
        }

        return (
            <Fragment>
                <ReactTable
                    data={myData}
                    columns={columns}
                    defaultPageSize={pageSize}
                    className={myClass}
                    showPagination={pagination}
                />
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Datatable_user
